import app from '../../../scripts/app';
import template from './phone-verify.jade';

app.directive('cianAfPhoneVerify', () => {
    return {
        template,
        scope: {},
        bindToController: {},
        controller: ['userService', 'apiService', function (userService, apiService) {
            this.phoneNumber = {};
            this.verifyPhone = phoneNumberToVerify => {
                return apiService.verifyPhone(phoneNumberToVerify).then(userService.setUserVerifiedPhoneNumber);
            };
        }],
        controllerAs: 'phoneVerifyCtrl',
        replace: true,
    };
});
